import { __assign, __rest } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import { Box } from '../layout/Box.js';
import { Stack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import '../typography/Text.js';
import '../typography/Display.js';
import { Heading } from '../typography/Heading.js';
import '../typography/Label.js';
import { Paragraph } from '../typography/Paragraph.js';
import React__default from 'react';
import styled from 'styled-components';
var iconPlacementStyle = {
  left: {
    minHeight: "72px"
  },
  top: {
    paddingLeft: "24px",
    paddingY: "24px"
  }
};
var StyledSelector = styled(Box)(function (_a) {
  var iconPlacement = _a.iconPlacement;
  return css(__assign(__assign({}, iconPlacementStyle[iconPlacement]), {
    cursor: "pointer",
    borderRadius: "16px",
    border: "base",
    borderColor: "grey.5",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 200ms ease-in-out",
    ":hover": {
      backgroundColor: "grey.8"
    }
  }));
});
var RightIconContainer = styled(Box)(css({
  transition: "all 200ms ease-in-out",
  minWidth: "56px",
  pl: "8px",
  color: "grey.1",
  "[role=group]:hover &": {
    color: "textPrimary",
    transform: "translateX(4px)"
  },
  "*": {
    color: "inherit"
  }
}));
var Selector = React__default.forwardRef(function (_a, ref) {
  var title = _a.title,
    description = _a.description,
    icon = _a.icon,
    _b = _a.iconPlacement,
    iconPlacement = _b === void 0 ? "left" : _b,
    rest = __rest(_a, ["title", "description", "icon", "iconPlacement"]);
  return React__default.createElement(StyledSelector, __assign({}, rest, {
    ref: ref,
    role: "group",
    iconPlacement: iconPlacement
  }), React__default.createElement(Box, {
    display: "flex",
    flexDirection: iconPlacement === "left" ? "row" : "column",
    alignItems: iconPlacement === "left" ? "center" : "left",
    justifyContent: "left"
  }, icon ? React__default.createElement(Box, {
    minWidth: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: iconPlacement === "left" ? "center" : "left",
    marginBottom: iconPlacement === "left" ? undefined : "16px"
  }, icon) : React__default.createElement(Box, {
    width: "16px"
  }), React__default.createElement(Stack, {
    direction: "column",
    spacing: iconPlacement === "left" ? "2px" : "8px"
  }, React__default.createElement(Heading, {
    size: "sm",
    width: "100%"
  }, title), description && React__default.createElement(Paragraph, {
    size: "sm",
    color: "grey.1"
  }, description))), React__default.createElement(RightIconContainer, null, React__default.createElement(Icon, {
    icon: "chevron_right",
    fontSize: "24px"
  })));
});
export { Selector };